import React, { Component, useEffect, useState } from "react";
import { CONSTANTS } from "../../constants/Constant";
import { DKButton } from 'deskera-ui-library'
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";

const FinishPayroll = (props) => {
    const payrunId = props.payrunId ? props.payrunId : CONSTANTS.EMPTY_STRING;
    const isContractor = props.isContractor || false;

    const routeToSummary = () => {
        RouteManager.navigateToPage(
            PAGE_ROUTES.PROCESS_SUMMARY,
            `id=${payrunId}&step=2&isContractor=${isContractor}`
        )
    }

    return (

        <div className="paid-card m-v-l parent-width bg-white p-l mt-l border-radius-m border-m">
            <div className="">
                <div className="column fs-xxl fw-s text-app">Click on Finish to finalize the payroll</div>
                <div className="column fs-l text-gray mt-s">Please find the summary for the payrun below to check before finalizing.</div>
                <div className="row flex-wrap mt-xxl">
                    <DKButton
                        className="border-m bg-app text-white"
                        title="View Summary"
                        onClick={() => {
                            routeToSummary()
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default FinishPayroll;